import React from 'react';

const PageHeader = ({title}) => {
  return (
    <section
      className="relative py-20 bg-no-repeat bg-cover bg-center"
      style={{ backgroundImage: "url('/assets/images/aboutpage/header-bg.jpg')" }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-white opacity-[0.8] z-0"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4">
        <div className="flex justify-center">
          <div className="text-center text-white">
            <h3 className="text-4xl font-semibold mb-2 opacity-[0.7]">{title}</h3>
            <p className="text-sm">
              <a href="/" className="hover:underline">Home</a> / {title}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHeader;
